import React from 'react';
import PropTypes from 'prop-types';
import { Link, useHistory, useLocation } from 'react-router-dom';

import { ROUTES } from 'config/constants';

import './Autocomplete.scss';

export function Autocomplete({
    productsList,
    categsList,
    closeList,
    rememberTheLastSearchItem
}) {
    const history = useHistory();
    const { pathname } = useLocation();

    return (
        <div className='search-admin__autocomplete container'>
            {categsList && !!categsList.length && (
                <p className='search-admin__autocomplete-subtitle'>
                    <span>CATEGORIES</span>
                </p>
            )}
            {categsList && categsList.map(cat => (
                <div
                    className='d-flex align-items-center search-admin__autocomplete-item'
                    onClick={() => {
                        closeList();
                        history.push({
                            pathname: ROUTES.PRODUCTS,
                            search: `?category[]=${cat?.id}&rental_period=12`
                        });
                    }}
                    key={cat?.id}>
                    <img className='mr-0' src={cat?.icon_url} alt={`Icon for ${cat?.name}`} />
                    {cat?.name}
                </div>
            ))}

            {productsList && !!productsList.length && (
                <div className='search-admin__autocomplete-subtitle'>
                    <span>TOP RESULTS</span>
                </div>
            )}
            {(productsList && productsList.length > 0) ? productsList.map(
                (product, i) =>
                    i < 5 && (
                        <div
                            className='search-admin__autocomplete-item'
                            onClick={() => rememberTheLastSearchItem(product)}
                            key={product?.id}>
                            <div>
                                <p className='search-admin__autocomplete-item-name'>
                                    {product?.name}
                                </p>
                            </div>
                        </div>
                    )
            ) : <span className='search-admin__autocomplete-noitem d-flex'><span>No results found! Try </span><a target='_blank' rel='noreferrer' href='https://www.cinch.sg'> cinch.sg</a></span>}
            {(pathname !== ROUTES.PRODUCTS && productsList.length > 1) && (
                <div className='search-admin__autocomplete-show'>
                    <Link to={ROUTES.PRODUCTS}>View All Products</Link>
                </div>
            )}
        </div>
    );
}

Autocomplete.propTypes = {
    productsList: PropTypes.array,
    categsList: PropTypes.array,
    closeList: PropTypes.func,
    rememberTheLastSearchItem: PropTypes.func
};
